import { Card } from 'components';

import { LinkGuard } from 'components/RoleGuard';
import { useColumnHeaders } from 'domain/hooks/useApiList';
import { Crop } from 'domain/models/api.models';
import { AppRoutes } from 'domain/routes';
import { stringifyMonthDay } from 'domain/utils';
import { maxLength } from 'domain/utils/string.utils';
import { CardListContext } from 'pages/base/CardList';
import { useContext } from 'react';

export const CropCard = ({ item }: { item: Crop }) => {
	return (
		<LinkGuard
			role='ROLE_ADMIN'
			to={AppRoutes.EditCrop.replace(':id', '' + item.id)}>
			<Card className={item.deleted ? 'border-0 opacity-50' : ''}>
				<Card.Header>
					<Card.Badge status={item.deleted ? 'OK' : 'ERROR'}></Card.Badge>
					<Card.Titles>
						<Card.Title>{`${item.name ?? '-'}`}</Card.Title>
						<Card.Subtitle></Card.Subtitle>
					</Card.Titles>
					<Card.Info>
						<Card.InfoItemLabel></Card.InfoItemLabel>
					</Card.Info>
				</Card.Header>
				<Card.Body>
					<Card.KeyValue></Card.KeyValue>
				</Card.Body>
			</Card>
		</LinkGuard>
	);
};

export const CropCardRow = ({ item }: { item: Crop }) => {
	const { rel } = useContext(CardListContext);
	const columns = useColumnHeaders<Crop>(rel);

	if (!item) {
		return <></>;
	}

	if (!item) {
		return <></>;
	}
	return (
		<LinkGuard
			role='ROLE_ADMIN'
			to={AppRoutes.EditCrop.replace(':id', '' + item.id)}>
			<div className='flex w-full flex-row justify-between'>
				{columns.map((key) => (
					<div className='w-full' key={`crop-${key}`}>
						{render(item, key)}
					</div>
				))}
			</div>
		</LinkGuard>
	);
};

const render = (value: Crop, field: string): string => {
	if (!value) {
		return '-';
	}

	if (!field) {
		return '-';
	}

	if (!(value as any)[field]) {
		return '-';
	}

	switch (field) {
		case 'creationDate':
			return stringifyMonthDay((value as any)[field]);
		default:
			return maxLength((value as any)[field]?.toString(), 40) ?? '-';
	}
};
